export default __webpack_public_path__ + "static/media/Vector.2f2c7d85.png";